/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_EyebrowInputs */

const tr_landing_cockpit_eyebrow = /** @type {(inputs: Landing_Cockpit_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`birleşik kokpit`)
};

const en_landing_cockpit_eyebrow = /** @type {(inputs: Landing_Cockpit_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unified cockpit`)
};

const de_landing_cockpit_eyebrow = /** @type {(inputs: Landing_Cockpit_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereintes Cockpit`)
};

const ru_landing_cockpit_eyebrow = /** @type {(inputs: Landing_Cockpit_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`единый кокпит`)
};

/**
* | output |
* | --- |
* | "unified cockpit" |
*
* @param {Landing_Cockpit_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_eyebrow = /** @type {((inputs?: Landing_Cockpit_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_eyebrow(inputs)
	if (locale === "de") return de_landing_cockpit_eyebrow(inputs)
	if (locale === "ru") return ru_landing_cockpit_eyebrow(inputs)
	return tr_landing_cockpit_eyebrow(inputs)
});